function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.25 21.25V14a.75.75 0 01.75-.75h6a.75.75 0 01.75.75v7.25H19c.69 0 1.25-.56 1.25-1.25v-7.5a.75.75 0 111.5 0V20A2.75 2.75 0 0119 22.75H5A2.75 2.75 0 012.25 20v-7.5a.75.75 0 111.5 0V20c0 .69.56 1.25 1.25 1.25h5.25zm1.5 0h4.5v-6.5h-4.5v6.5zM1.584 9.624a.75.75 0 01-.273-.92l3-7A.75.75 0 015 1.25h14c.3 0 .571.179.69.455l3 7a.75.75 0 01-.274.919c-1.118.745-2.26 1.126-3.416 1.126-.784 0-1.237-.165-1.997-.599-.553-.316-.787-.401-1.253-.401-.403 0-.663.077-1.107.298l-.245.123c-.805.402-1.424.579-2.398.579-.974 0-1.593-.177-2.398-.58l-.245-.122c-.444-.22-.704-.298-1.107-.298-.466 0-.7.085-1.253.401-.76.434-1.213.599-1.997.599-1.156 0-2.298-.38-3.416-1.126zM5 9.25c.466 0 .7-.085 1.253-.401.76-.434 1.213-.599 1.997-.599.67 0 1.14.14 1.774.454l.249.125c.612.306 1.014.421 1.727.421.713 0 1.115-.115 1.727-.42.12-.062.196-.1.249-.126.633-.314 1.103-.454 1.774-.454.784 0 1.237.165 1.997.599.553.316.787.401 1.253.401.674 0 1.356-.182 2.053-.555L18.505 2.75H5.495L2.947 8.695c.697.373 1.38.555 2.053.555z"
  }));
};
SvgShop.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgShop.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgShop;